// extracted by mini-css-extract-plugin
module.exports = {"showcase":"Showcase_showcase__EA3Ub","flexRow":"Showcase_flexRow__3ZEGq","navbar":"Showcase_navbar__3QQzN","logo":"Showcase_logo__2CJIM"};